export default __webpack_public_path__ + "static/media/banner9.6e7c7a99.png";